// Copy shared by everywhere a client can pass on their referral link: the
// dashboard card and the public share page.

import { TRUSTPILOT } from "../constants";
import { formatMoneyWithCurrency, moneyStrToNum } from "../shared/utils/moneyUtils";

export const CLIENT_REFERRAL_TERMS_URL = "https://www.juno.legal/client-referral-terms/";

// Backs the Trustpilot rating claim in the shared message.
export const REFERRAL_SHARE_RATINGS_LINE = `See the Trustpilot reviews: ${TRUSTPILOT.reviewUrl}`;

// When the referrer gets their voucher, worded once for every place it is
// shown. The short form is for headings and buttons.
export const REWARD_CONDITION = "once their sale is agreed and we’ve received the memorandum of sale";
export const REWARD_CONDITION_SHORT = "once their sale is agreed";
// Seller-facing variants: the reader is the seller and "their" would point at the buyer.
export const BUYER_REWARD_CONDITION = "once the sale is agreed and we’ve received the memorandum of sale";
export const BUYER_REWARD_CONDITION_SHORT = "once the sale is agreed";

// An amount from the referral code as it appears in copy: "£100" from the
// code's "£100.00", keeping any pence ("£75.50").
export const amountForCopy = (amount) => formatMoneyWithCurrency(moneyStrToNum(amount));

// The reward as it appears in copy, or null where the code carries no reward.
// The amount comes from the synced referral code, never from here.
export const rewardForCopy = (rewardAmount) => (moneyStrToNum(rewardAmount) > 0 ? amountForCopy(rewardAmount) : null);

// "a £200 voucher", or "a voucher" where the code carries no reward
export const voucherForCopy = (rewardAmount) => {
  const reward = rewardForCopy(rewardAmount);
  return reward ? `a ${reward} voucher` : "a voucher";
};

// The pre-written share message; ShareReferralLink appends the link. Without a
// transaction type (the public share page) it speaks of a past move.
export const referralShareText = (discount, transactionType) => {
  const usingJuno = {
    purchase: "I’m using them for my purchase",
    sale: "I’m using them for my sale",
    buyingandselling: "I’m using them for my move",
  };
  const experience = usingJuno[transactionType] ?? "I used them when I moved";
  return `Juno are ${TRUSTPILOT.ratingLongText}. ${experience}. Sign up with my link and you’ll get ${discount} off:`;
};

export const referralEmailSubject = (discount) => `${discount} off your conveyancing with Juno`;
